import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import StyleIcon from '@mui/icons-material/Style'
import AddIcon from '@mui/icons-material/Add'
import Logo from './logo/Logo'
import {Link} from 'react-router-dom'
import AuthNav from './auth/AuthNav'

export default function NavBar() {
  return (
    <AppBar position="static">
      <Toolbar
        disableGutters
        sx={{
          width: "100%",
          display: "flex",
          color: (theme) =>
            theme.palette.mode === "dark" ? "grey.300" : "grey.800",
          borderRadius: 2,
          fontSize: "0.875rem",
          fontWeight: "700",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            alignSelf: "center",
            width: {xs: "15%", md: "20%"},
            display: {xs: "flex"},
          }}
        >
          <Link to="/" style={{textDecoration: "none", color: "inherit"}}>
            <Box sx={{mr: {xs: 0, md: 2}, mt: 1, ml: '8px'}}>
              <Logo/>
            </Box>
          </Link>
          <Box
            sx={{
              display: {xs: "none", sm: "none", md: "none", lg: "flex"}
            }}
          >
            <Link to="/" style={{textDecoration: "none", color: "inherit"}}>
              <Typography
                variant="h4"
                textAlign="center"
                noWrap
                component="div"
                sx={{mr: 2}}
              >
                Flashcards
              </Typography>
            </Link>
          </Box>
        </Box>

        <Box
          sx={{
            width: {xs: "70%", md: "80%"},
            alignItems: "center",
            justifyContent: {xs: "space-evenly", sm: "center"},
            display: {xs: "flex"},
            

          }}
        >
          <Box
            sx={{
              px: {xs: 0, sm: 3},
            }}>
            <Link to="/my-decks" style={{textDecoration: "none", color: "inherit"}}>
              <Button startIcon={<StyleIcon sx={{mb: 0.3, mr: 0}}/>}
                      variant="outlined"
                      color="success"
                      sx={{
                        px: {sm: 3},
                        color: "white",
                        display: "flex",
                        fontSize: '16px',
                        textTransform: 'none',
                      }}
                      size='small'
              >
                My Decks
              </Button>
            </Link>
          </Box>
          <Box>
            <Link to="/new-deck" style={{textDecoration: "none", color: "inherit"}}>
              <Button
                startIcon={<AddIcon color="success" sx={{mb: 0.3, mr: 0}}/>}
                variant="outlined"
                color="success"
                sx={{
                  px: {sm: 3},
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  fontSize: '16px',
                  textTransform: 'none',
                }}
                size='small'
              >
                New Deck
              </Button>
            </Link>
          </Box>
        </Box>

        <Box
          sx={{
            alignItems: "center",
            alignSelf: "center",
            width: {xs: "15%", md: "20%"},
            display: "flex",
            justifyContent: "right",
          }}>
          <AuthNav/>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
